import {
  Link,
  useRouter,
} from 'found';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';
import React, {
  Fragment,
  useCallback,
  useMemo,
} from 'react';
import HTMLFragment from 'components/HTMLFragment';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  indicator: {
  },
  tab: {
    minWidth: 50,
    padding: '0 20px',
    height: 48,
    textTransform: 'none',
    fontWeight: '600',
  },
}));

const styles = {
  inkBar: {
    marginTop: -4,
    height: 4,
  },
  menuButton: {
    padding: 0,
    width: null,
    marginRight: 8,
  },
  selectedMenuItem: {
  },
  tab: {
    padding: '0 20px',
    height: 48,
    textTransform: 'none',
    fontWeight: '600',
  },
  tabsItemContainer: {
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 16,
    fontWeight: '500',
    height: 48,
    flex: 1,
    padding: 0,
    margin: 0,
  },
  toolbarGroup: {
  },
  toolbarSeparator: {
    marginRight: 8,
  },
  toolbarTitle: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
    flexGrow: 1,
    fontWeight: '600',
    textOverflow: 'ellipsis',
    fontSize: 'inherit',
    color: 'inherit',
    height: 48,
    paddingRight: 0,
    width: '100%',
  },
  toolbarLink: {
    textDecoration: 'underline',
    fontWeight: '600',
    marginRight: 4,
  },
};

const AppBar = ({ backLink, links: unfilteredLinks, title, titleLink }) => {
  const classes = useStyles();
  const { match: { location: { pathname } }, router } = useRouter();
  const links = useMemo(
    () => (unfilteredLinks
        ? unfilteredLinks.filter(link => !link.skip)
        : null
    ),
    [unfilteredLinks],
  );
  const linkValue = useMemo(
    () => (links
      ? links.reduce(
        (value, link) => (
          link.path && pathname.indexOf(link.path) !== -1
            ? link.path
            : value
        ),
        null,
      )
      : null),
    [
      links,
      pathname,
    ],
  );
  const onTabChange = useCallback(
    (event, link) => {
      const item = links.find((l) => l.path === link);
      if (item.handler) {
        item.handler();
      } else if (item.path) {
        router.push(item.path);
      }
    },
    [router, links],
  );
  const renderTab = useCallback(
    (link, idx) => (
      <Tab
        key={idx}
        label={link.label}
        style={styles.tab}
        classes={{ root: classes.tab }}
        value={link.path}
      />
    ),
    [classes],
  );
  const renderTitle = useCallback(
    () => (
      <HTMLFragment>
        {title}
      </HTMLFragment>
    ),
    [title],
  );
  return (
    <Toolbar style={styles.toolbar} variant='dense'>
      <Box containerElement='div' style={styles.toolbarGroup}>
        <Typography style={styles.toolbarTitle}>
          <Fragment>
            {backLink && (
              <Fragment>
                <Link
                  key={backLink.label}
                  to={backLink.href}
                  style={styles.toolbarLink}
                >
                  <HTMLFragment style={styles.toolbarLink}>
                    {backLink.label}
                  </HTMLFragment>
                </Link>
                <span style={styles.toolbarSeparator}>
                  &gt;
                </span>
              </Fragment>
            )}
            {titleLink
              ? (
                <Link
                  to={titleLink}
                  style={styles.toolbarLink}
                >
                  {renderTitle()}
                </Link>
              )
              : renderTitle()}
          </Fragment>
        </Typography>
      </Box>
      <Box style={styles.toolbarGroup}>
        {links && (
          <Tabs
            variant='standard'
            inkBarStyle={styles.inkBar}
            onChange={onTabChange}
            style={styles.tabsItemContainer}
            value={linkValue}
            classes={{ indicator: classes.indicator }}
          >
            {links.map(renderTab)}
          </Tabs>
        )}
      </Box>
    </Toolbar>
  );
};

AppBar.propTypes = {
  backLink: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
  links: PropTypes.array,
  title: PropTypes.string.isRequired,
  titleLink: PropTypes.string,
};

export default AppBar;
